(() => {
  if (customElements.get('blog-section-grid')) return;

  class BlogSectionGrid extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-grid-card]'));
      this.handleClick = this.onClick.bind(this);
      this.addEventListener('click', this.handleClick);
      this.loadMissingArticles();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.articleRequestController?.abort();
    }

    onClick(event) {
      const viewAll = event.target.closest('[data-view-all]');
      if (!viewAll || !this.contains(viewAll)) return;

      const targetPath = new URL(viewAll.href, window.location.origin).pathname;
      const headerTag = Array.from(document.querySelectorAll('.blog-header__tag')).find((tag) => {
        return new URL(tag.href, window.location.origin).pathname === targetPath;
      });

      event.preventDefault();

      if (headerTag) {
        headerTag.click();
        return;
      }

      const filterResults = document.querySelector('blog-filter-results');
      if (filterResults?.renderUrl) {
        const header = document.querySelector('[data-blog-header]');
        header?.querySelectorAll('.blog-header__tag').forEach((tag) => {
          const isActive = new URL(tag.href, window.location.origin).pathname === targetPath;
          tag.classList.toggle('is-active', isActive);
          if (isActive) tag.setAttribute('aria-current', 'page');
          else tag.removeAttribute('aria-current');
        });

        filterResults.renderUrl(viewAll.href, { scrollToResults: true }).catch((error) => {
          if (error?.name !== 'AbortError') window.location.assign(viewAll.href);
        });
        return;
      }

      window.location.assign(viewAll.href);
    }

    async loadMissingArticles() {
      const shouldLoad =
        this.dataset.autoArticles === 'true' &&
        this.dataset.filterContext !== 'true' &&
        Boolean(this.dataset.filterTag) &&
        Boolean(this.dataset.filterUrl) &&
        Boolean(this.dataset.sectionId) &&
        this.cards.length < 4 &&
        !this.hasRequestedArticles;

      if (!shouldLoad) return;

      this.hasRequestedArticles = true;
      this.articleRequestController = new AbortController();
      this.querySelector('[data-grid-cards]')?.setAttribute('aria-busy', 'true');

      try {
        const requestUrl = new URL(this.dataset.filterUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);

        const response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          signal: this.articleRequestController.signal,
        });

        if (!response.ok) throw new Error(`Article request failed: ${response.status}`);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const newSection = html.querySelector('blog-section-grid');
        const sourceCardCount = newSection?.querySelectorAll('[data-grid-card]').length || 0;

        if (!newSection || sourceCardCount < this.cards.length) return;

        this.replaceWith(newSection);
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      } finally {
        this.querySelector('[data-grid-cards]')?.removeAttribute('aria-busy');
      }
    }

    async blogUpdate(url) {
      const filterResults = document.querySelector('blog-filter-results');
      if (filterResults?.renderUrl) {
        return filterResults.renderUrl(url, { scrollToResults: true });
      }

      window.location.assign(url);
    }
  }

  customElements.define('blog-section-grid', BlogSectionGrid);
})();
